/**
* Component PopupButton
*
* Open a popup when the button is clicked
*
* Props : 
* - background (String) : background on the button. By default the parameter is brown
*
* Method : 
* - backgroundClass (computed) : if the value of the props "background" is blue. "BackgroundClass" call the css "link_brown". Otherwise he calls "link_blue"
* - handleClick (methods) : send a event to the parent "show-more" is the name of event. The parent can listen the event for react. "$emit" allow comunicate parent and child with un personnalise event
* 
*/

<template>
    <button @click="handleClick" data-aos="fade" data-aos-duration="500" data-aos-easing="ease-in-out"  data-aos-once="true">{{$t("popupButton.text")}}</button>
</template>

<script>
 export default{
    name:"PopupButton",

    methods: {
        handleClick(){
            this.$emit("show-more"); //Emet un évènement vers le parent
        },
    },
}
</script>
